import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import emoji from './emoji.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import teamsSettings from './teamsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';
import sla from './sla.json';
import inbox from './inbox.json';
import general from './general.json';
import datePicker from './datePicker.json';
// Importar todos los archivos JSON de inglés
import kanban from './kanban.json';
import contactTracking from './contactTracking.js';

import trackingTemplates from './trackingTemplates.json'; // proyecto@tracking_templates
import knowledgeSources from './knowledgeSources.js'; // @knowledge_sources
import googleCalendar from './googleCalendar.js'; // proyecto@google_calendar
import gestorTickets from './gestorTickets.json'; // @tickets_cases
import erp from './erp.json'; // @query_databases
import bulkTrackingAssign from './bulkTrackingAssign.json'; // proyecto@bulk_tracking_assign
import trackingCampaigns from './trackingCampaigns.json'; // @campanas_vendedor
import trackingAssistant from './trackingAssistant.json'; // proyecto@asistente_agentes_ia
import whatsappCalls from './whatsappCalls.json'; // diag/llamadas_whatsapp

export default {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...emoji,
  ...generalSettings,
  ...helpCenter,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...teamsSettings,
  ...whatsappTemplates,
  ...inbox,
  ...general,
  ...datePicker,
  ...kanban,
  ...contactTracking,
  ...trackingTemplates, // proyecto@tracking_templates
  ...knowledgeSources, // @knowledge_sources
  ...googleCalendar, // proyecto@google_calendar
  ...gestorTickets, // @tickets_cases
  ...erp, // @query_databases
  ...bulkTrackingAssign, // proyecto@bulk_tracking_assign
  ...trackingCampaigns, // @campanas_vendedor
  ...trackingAssistant, // proyecto@asistente_agentes_ia
  ...whatsappCalls, // diag/llamadas_whatsapp
};
